module.exports = __webpack_public_path__ + "img/topsOff.dd401be7.svg";